/* Device controls for the local development preview only. */
(() => {
  if (window.self !== window.top) {
    const previewBase = new URL(document.baseURI);
    if (!['127.0.0.1', 'localhost'].includes(previewBase.hostname)) return;
    // Fragment links stay in the preview; local page changes load in the top frame.
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank' || event.ctrlKey || event.metaKey || event.shiftKey) return;
      const target = new URL(link.href, previewBase);
      if (target.origin !== previewBase.origin) return;
      if (target.pathname === previewBase.pathname && target.search === previewBase.search && target.hash) {
        const anchor = document.getElementById(decodeURIComponent(target.hash.slice(1)));
        if (anchor) { event.preventDefault(); anchor.scrollIntoView({ behavior: 'auto', block: 'start' }); }
      } else if (target.pathname !== '/cart') {
        event.preventDefault();
        window.top.location.href = target.href;
      }
    });
    // Deferred scripts run after the blocking stylesheets. Reveal the preview once its DOM is ready.
    const announceReady = () => requestAnimationFrame(() => {
      window.parent.postMessage({ type: 'hn-preview-ready' }, previewBase.origin);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', announceReady, { once: true });
    else announceReady();
    return;
  }
  if (!['127.0.0.1', 'localhost'].includes(location.hostname) || new URLSearchParams(location.search).has('hn-preview-raw')) return;

  const source = document.documentElement.cloneNode(true);
  source.classList.remove('hn-preview-pending');
  const base = document.createElement('base');
  base.href = location.href;
  source.querySelector('head').prepend(base);
  // Event listeners aren't cloned. Let the theme initialize them in the preview.
  source.querySelectorAll('[data-initialized]').forEach(element => element.removeAttribute('data-initialized'));
  source.querySelectorAll('form[data-hn-bound]:not(.hn-product__form)').forEach(form => form.removeAttribute('data-hn-bound'));
  source.querySelectorAll('form').forEach(form => { form.target = '_top'; });

  const style = document.createElement('style');
  style.textContent = `
    html, body { margin: 0 !important; overflow: hidden !important; }
    .preview-controls { height: 60px; box-sizing: border-box; display: flex; align-items: center;
      justify-content: center; gap: 8px; background: #fff; border-bottom: 1px solid #cfdbdd;
      font: 14px Arial, sans-serif; }
    .preview-controls button { padding: 9px 16px; border: 1px solid #b8cdd2; border-radius: 8px;
      background: #fff; color: #153e49; cursor: pointer; font: inherit; }
    .preview-controls button[aria-pressed="true"] { background: #153e49; color: #fff; border-color: #153e49; }
    .preview-controls button:focus-visible { outline: 3px solid #b9802c; outline-offset: 2px; }
    .preview-stage { height: calc(100dvh - 60px); position: relative; background: #f7f5ef; overflow: hidden; }
    .preview-frame { position: absolute; top: 0; border: 0; background: #fff; transform-origin: top left; }
  `;
  document.head.append(style);
  const controls = document.createElement('nav');
  controls.className = 'preview-controls';
  controls.setAttribute('aria-label', 'Format de prévisualisation');
  const stage = document.createElement('div');
  stage.className = 'preview-stage';
  const frame = document.createElement('iframe');
  frame.className = 'preview-frame';
  frame.title = 'Prévisualisation du site';
  frame.style.visibility = 'hidden';
  let previewVisible = false;
  const revealPreview = () => {
    if (previewVisible) return;
    previewVisible = true;
    frame.style.visibility = 'visible';
    window.removeEventListener('message', onPreviewReady);
    clearTimeout(previewFallback);
  };
  const onPreviewReady = event => {
    if (event.source === frame.contentWindow && event.origin === location.origin && event.data?.type === 'hn-preview-ready') revealPreview();
  };
  window.addEventListener('message', onPreviewReady);
  frame.addEventListener('load', revealPreview, { once: true });
  const previewFallback = setTimeout(revealPreview, 5000);
  frame.srcdoc = '<!doctype html>' + source.outerHTML;
  stage.append(frame);
  let mode = sessionStorage.getItem('hn-preview-device') || 'desktop';
  const buttons = [];
  function resize() {
    const width = mode === 'phone' ? 390 : 1440;
    const scale = Math.min(1, stage.clientWidth / width);
    frame.style.width = `${width}px`;
    frame.style.height = `${stage.clientHeight / scale}px`;
    frame.style.transform = `scale(${scale})`;
    frame.style.left = `${Math.max(0, (stage.clientWidth - width * scale) / 2)}px`;
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mode === mode)));
  }
  [['phone', 'Téléphone'], ['desktop', 'Ordinateur']].forEach(([value, label]) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label;
    button.dataset.mode = value;
    button.addEventListener('click', () => {
      mode = value;
      sessionStorage.setItem('hn-preview-device', mode);
      resize();
    });
    buttons.push(button);
    controls.append(button);
  });
  document.body.replaceChildren(controls, stage);
  window.addEventListener('resize', resize);
  resize();
  clearTimeout(window.hnPreviewRevealFallback);
  document.documentElement.classList.remove('hn-preview-pending');
})();
